/**
 * @fileoverview GET handler for the "/apps/:app_group_id/messaging_rules" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdMessagingRules } from "./constants";
import type { AppsAppGroupIdMessagingRulesResult } from "./types";

export const getAppsAppGroupIdMessagingRules = reactQueryFetcherAdapter(
  appsAppGroupIdMessagingRules,
  (signal: AbortSignal, appGroupId: string): Promise<AppsAppGroupIdMessagingRulesResult> => {
    return fetch(`/apps/${appGroupId}/messaging_rules`, "GET", {}, { signal });
  }
);
